import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Delete, Get, Post, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { prepareData } from "../helpers/apiHelper";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useEmailTemplates = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["email-templates", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.EMAIL_TEMPLATES.base}?${appendQueryParams({params})}`,
                token,
                toastError: true,
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useEmailTemplatesFacet = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["emailTemplatesFacet"],
        queryFn: async () => {
            const { data } = await Get({
                path: API_CONSTANTS.EMAIL_TEMPLATES.getFacet,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useCreateEmailTemplate = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.EMAIL_TEMPLATES.dataKeys)
            const { data } = await Post({
                path: API_CONSTANTS.EMAIL_TEMPLATES.base,
                token,
                body
            })
            return data
        },
    })
}

export const useUpdateEmailTemplate = (id) => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.EMAIL_TEMPLATES.dataKeys)
            const { data } = await Put({
                path: `${API_CONSTANTS.EMAIL_TEMPLATES.base}/${id}`,
                token,
                body
            })
            return data
        },
    })
}

export const useDeleteEmailTemplate = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (id) => {
            const { data } = await Delete({
                path: `${API_CONSTANTS.EMAIL_TEMPLATES.base}/${id}`,
                token,
            })
            return data
        },
    })
}